// extracted by mini-css-extract-plugin
export default {"wrapper":"AKmsreEX","root":"KAcPVCYw","commigCard":"QnxQDq2M","notificationText":"b0B2MP2G","successContainer":"I4EPKKQN","errorContainer":"aFeS9Kr8","error":"dv82KByW"};